import { render } from "./debug.vue?vue&type=template&id=4275857a&scoped=true&ts=true"
import script from "./debug.vue?vue&type=script&lang=ts"
export * from "./debug.vue?vue&type=script&lang=ts"

import "./debug.vue?vue&type=style&index=0&id=4275857a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.40_webpack@5.109.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4275857a"]])

export default __exports__